import { Injectable } from '@angular/core';
export interface SelectedOrg {
  _id: string;
  name: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class SelectedOrgService {

  private readonly STORAGE_KEY = 'lastSelectedOrg';
  private readonly MULTI_ORG_KEY = 'lastSelectedOrgs';

  private lastSelectedOrg: SelectedOrg | null = null;
  private lastSelectedOrgs: SelectedOrg[] | null = null;

  constructor() {
    const stored = sessionStorage.getItem(this.STORAGE_KEY);
    if (stored && stored !== 'undefined' && stored !== 'null') {
      try {
        this.lastSelectedOrg = JSON.parse(stored);
      } catch (e) {
        console.error('Error parsing lastSelectedOrg from localStorage', e);
        this.lastSelectedOrg = null;
      }
    }

    const storedMulti = sessionStorage.getItem(this.MULTI_ORG_KEY);
    if (storedMulti && storedMulti !== 'undefined' && storedMulti !== 'null') {
      try {
        this.lastSelectedOrgs = JSON.parse(storedMulti);
      } catch (e) {
        console.log('Error parsing lastSelectedOrgs from sessionStorage', e);
        this.lastSelectedOrgs = null;
      }
    } else if (storedMulti === '[]') {
      this.lastSelectedOrgs = [];
    } else {
      this.lastSelectedOrgs = null;
    }
  }

  setSelectedOrg(org: SelectedOrg | null) {
    this.lastSelectedOrg = org;
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(org));
  }

  getSelectedOrg(): SelectedOrg | null {
    return this.lastSelectedOrg;
  }

  clearSelectedOrg() {
    this.lastSelectedOrg = null;
    sessionStorage.removeItem(this.STORAGE_KEY);
  } 

  setSelectedOrgs(orgs: SelectedOrg[] | null) {
    this.lastSelectedOrgs = orgs;
    sessionStorage.setItem(this.MULTI_ORG_KEY, JSON.stringify(orgs));
  }

  getSelectedOrgs(): SelectedOrg[] | null {
    return this.lastSelectedOrgs;
  }

  clearSelectedOrgs() {
    this.lastSelectedOrgs = [];
    sessionStorage.setItem(this.MULTI_ORG_KEY, JSON.stringify([]));
  }

  clearAll() {
    this.clearSelectedOrg();
    this.clearSelectedOrgs();
  }
}
